import { api } from "./client";
import type { BuyerSubmissionStatus, ListingAgentBriefDto } from "./buyers";

// Addendum B (B2, B3) — "Who's calling?": a broker's listings and the buyers
// presented on each, from any fragment of them. Mirrors WhosCallingDtos.cs.

export interface WhosCallingParams {
  q?: string;
  /** VIEW DEALS: one agent's deals; the query is ignored. */
  agentId?: string;
}

export interface WhosCallingMessageDto {
  /** "email", "text", "web form" or "package". */
  channel: string;
  sentAtUtc: string;
  sentByName?: string | null;
}

export interface WhosCallingBuyerDto {
  submissionId: string;
  buyerLeadId: string;
  buyerName: string;
  ownerName?: string | null;
  status: BuyerSubmissionStatus;
  lastMessageToBroker?: WhosCallingMessageDto | null;
}

export interface WhosCallingListingDto {
  listingId: string;
  displayName: string;
  city?: string | null;
  state?: string | null;
  askingPrice?: number | null;
  buyers: WhosCallingBuyerDto[];
}

export interface WhosCallingAgentDto {
  agent: ListingAgentBriefDto;
  listings: WhosCallingListingDto[];
}

export interface WhosCallingResultDto {
  agents: WhosCallingAgentDto[];
  listingsWithNoAgent: WhosCallingListingDto[];
  moreAgents: boolean;
  moreListings: boolean;
}

export const whosCallingApi = {
  search: (params: WhosCallingParams) => api.get<WhosCallingResultDto>("/listings/whos-calling", params),
};
